import { Button, Select, Space } from 'antd'
import Modal from 'antd/es/modal/Modal'
import { Order } from '../../../Types/order.interface'
import veg from '../../../assets/veg.png'
import nonveg from '../../../assets/non-veg.png'
import './orderItemModal.scss'
import { useEffect, useState } from 'react'
import { TZDate } from '@date-fns/tz'
import { format } from 'date-fns'
const OrderItemModal = ({
  visible,
  orderItem,
  onAccept,
  onReject
}: {
  visible: boolean
  orderItem: Order
  onAccept: (orderItem: Order) => void
  onReject: (orderItem: Order, reason: string) => void
}) => {
  const [rejectModal, setRejectModal] = useState<boolean>(false)
  const [orderItemSelected, setOrderItemSelected] = useState('')
  const [rejectReason, setRejectReason] = useState('')
  const [orderItemsList, setOrderItemsList] =
    useState<{ label: string; value: string }[]>()
  const orderRejectList = [{ label: 'Out of stock', value: 'OOS' }]
  useEffect(() => {
    setOrderItemsList(
      orderItem?.orderItems?.map((item) => {
        const itemLabel = item.label || 'Unknown Item'
        return { label: itemLabel, value: itemLabel }
      })
    )
    console.log(orderItemsList)
  }, [orderItem])

  // console.log(visible, orderItem)
  const handleAcceptOrder = () => {
    console.log('close')
    onAccept(orderItem)
  }

  const onRejected = () => {
    console.log('reject')
    setRejectModal(true)
  }

  const rejectWithReason = () => {
    console.log('hi')
    setRejectModal(false)
    onReject(orderItem, rejectReason)
    // alert(`Please set ${orderItemSelected} to not-available in Menu to avoid more orders with item ${orderItemSelected}`)
  }

  const onCancel = () => {
    setRejectModal(false)
  }

  return (
    <>
      <Modal
        title={
          <div
            style={{
              background: '#363641',
              padding: '10px',
              borderRadius: '10px'
            }}
          >
            <h2
              style={{
                textAlign: 'left',
                padding: ' 0px 10px',
                fontSize: '20px',
                color: 'white',
                margin: 0,
                flex: 1
              }}
            >
              {' '}
              Reject Reason{' '}
            </h2>
          </div>
        }
        centered
        closable={false}
        open={rejectModal}
        footer={
          <div
            style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}
          >
            <Button
              disabled={rejectReason && orderItemSelected ? false : true}
              style={{ width: '40%' }}
              type='primary'
              onClick={() => rejectWithReason()}
            >
              Accept
            </Button>
            <Button style={{ width: '40%' }} onClick={onCancel}>
              Cancel
            </Button>
          </div>
        }
        style={{ textAlign: 'center', width: '100%' }}
      >
        <Space>
          <Select
            showSearch
            placeholder='Select a Food Item'
            options={orderItemsList}
            onSelect={(e) => setOrderItemSelected(e)}
            value={orderItemSelected}
            size='large'
            style={{ width: '200px' }}
          />
          <Select
            showSearch
            placeholder='Select a Reason'
            options={orderRejectList}
            onSelect={(e) => setRejectReason(e)}
            value={rejectReason}
            size='large'
            style={{ width: '200px' }}
          />
        </Space>
      </Modal>

      <Modal
        title={
          <div
            style={{
              background: '#363641',
              padding: '10px',
              borderRadius: '10px'
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '10px',
                justifyContent: 'flex-start',
                alignItems: 'center',
                zIndex: 1
              }}
            >
              <h2
                style={{
                  textAlign: 'left',
                  padding: ' 0px 10px',
                  fontSize: '20px',
                  color: 'white',
                  margin: 0,
                  flex: 1
                }}
              >
                {' '}
                OrderNo: {orderItem?.orderId}{' '}
              </h2>
              <p
                style={{
                  background: 'green',
                  padding: '5px',
                  color: 'white',
                  margin: '15px 10px 0px 0px'
                }}
              >
                {orderItem?.orderType}
              </p>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '6px',
                justifyContent: 'flex-start',
                alignItems: 'center',
                padding: '0px 5px',
                color: 'white'
              }}
            >
              <p style={{ margin: 0, padding: '0px 0px 0px 10px' }}>
                {format(orderItem?.orderDateTime, 'hh:mm')}
              </p>
              <p style={{ margin: 0 }}>|</p>
              <p style={{ margin: 0 }}>
                {orderItem?.orderItems.length} items for &#8377;{' '}
                {orderItem?.totalAmount}
              </p>
              <p style={{ margin: 0 }}>|</p>
              <p style={{ margin: 0 }}>
                Reach Time:
                {orderItem?.orderReachTime &&
                  format(
                    new TZDate(
                      new Date(+orderItem?.orderReachTime),
                      'Asia/Kolkata'
                    ),
                    'h:mm a'
                  )}
              </p>
            </div>
          </div>
        }
        centered
        closable={false}
        open={visible}
        footer={
          <div
            style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}
          >
            <Button
              style={{ width: '40%' }}
              type='primary'
              onClick={() => handleAcceptOrder()}
            >
              Accept
            </Button>
            <Button style={{ width: '40%' }} onClick={onRejected}>
              MarkOutOfStock
            </Button>
          </div>
        }
        style={{ textAlign: 'center', width: '100%' }}
      >
        {orderItem?.orderItems?.map((item) => {
          return (
            <div className='item_contianer' key={item.label}>
              <div className='item_details'>
                <h5>{item.label}</h5>
                <p>{item.subCategory}</p>
                <div className='itemType'>
                  {item.type === 'VEG' && <img src={veg} />}
                  {item.type === 'NONVEG' && <img src={nonveg} />}
                  <p>&#8377;{item.price}.00</p>
                </div>
              </div>
              <div className='item_quantity'>X{item.quantity}</div>
            </div>
          )
        })}
        <div className='order_summary'>
          <div className='order_headings'>
            <p>Item total</p>
            <p>Packaging Charges</p>
            <p>GST</p>
            {/* <p>Discount</p> */}
          </div>
          <div className='order_values'>
            <div className='qtotal_quantity'>
              <p>{orderItem?.orderItems.length} items</p>
            </div>
            <div className='orderSub_values'>
              <p>&#8377;{orderItem?.totalAmount}</p>
              <p>
                &#8377;
                {orderItem?.orderItems.reduce((total, item) => {
                  return total + Number(item.packagingCharges || 0)
                }, 0) || 0}
                .00
              </p>
              <p>
                &#8377;
                {orderItem?.gst}
              </p>
              {/* <p>&#8377;
                
              </p> */}
            </div>
          </div>
        </div>
        {orderItem?.comments && (
          <div className='order_comments' style={{ textAlign: 'left', padding: '10px', marginTop: '10px', background: '#f9f9f9', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
            <h5 style={{ margin: '0 0 5px 0', color: '#333' }}>Instructions</h5>
            <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>{orderItem.comments}</p>
          </div>
        )}
      </Modal>
    </>
  )
}

export default OrderItemModal
